// games/shared/asset-base.ts -- resolve a same-origin static asset URL
// under the build's configured base path.
//
// The standalone trippi.app build uses Vite base "/" so assets live at the
// domain root (/tracks/..., /assets/...). Tenant builds set ARCADE_BASE=
// "/trippi/" (see arcade/vite.config.ts) so the same bundle serves under
// tenant.tld/trippi/ via same-origin path routing. Vite rewrites its own
// emitted /assets/* references automatically, but hand-written absolute
// fetch paths (the /tracks/*.json manifests) do NOT get rewritten -- they
// must be prefixed at runtime through this helper or they 404 under the
// /trippi/ prefix.
//
// BASE_URL is injected by Vite at build time ("/", "/trippi/", ...). It
// always carries a trailing slash. The vitest "node" environment has no
// import.meta.env, so we fall back to "/".

function baseUrl(): string {
  const env = (import.meta as unknown as { env?: { BASE_URL?: string } }).env;
  return env?.BASE_URL ?? "/";
}

/**
 * Prefix a root-absolute static asset path with the build base.
 *
 *   assetUrl("/tracks/tag/svolvaer.v1.json")
 *     base "/"        -> "/tracks/tag/svolvaer.v1.json"
 *     base "/trippi/" -> "/trippi/tracks/tag/svolvaer.v1.json"
 *
 * Leaves protocol-absolute URLs (http://, https://, //) untouched so
 * external tile/router/leaderboard hosts pass through unchanged.
 */
export function assetUrl(path: string): string {
  if (/^([a-z]+:)?\/\//i.test(path)) return path;
  const base = baseUrl().replace(/\/+$/, "");
  const rel = path.replace(/^\/+/, "");
  return `${base}/${rel}`;
}
